import { cn } from '@/lib/utils'

export const DEVELOPER = { name: 'rdoria.com', url: 'https://rdoria.com' } as const

/** Credit to who built Nolens. Underlined so the link is not told apart by colour alone. */
export function DevelopedBy({ className }: { className?: string }) {
  return (
    <span className={cn('text-fg-subtle', className)}>
      Desenvolvido por{' '}
      <a href={DEVELOPER.url} target="_blank" rel="noopener noreferrer" className="underline decoration-border-strong underline-offset-2 hover:text-fg hover:decoration-current">
        {DEVELOPER.name}
      </a>
    </span>
  )
}
